import { React, Button, Text } from "react";

function Chaintext(props) {
    
  // console.log(props.fraza,"props.fraza");
  // console.log(props.peptid,"props.peptyd");
  
    let index = props.peptid.search(props.fraza);
    let begin = props.peptid.substr(0,index);
    let middle = props.peptid.substr(index,props.fraza.length);
    let end = props.peptid.substr(index+props.fraza.length,props.peptid.length);
  return (
    <p>
      <text style={{color: "black"}}>{begin}</text>
      <text style={{color: "red"}}>{middle}</text>
      <text style={{color: "black"}}>{end}</text>
      </p>
  );
}

export default Chaintext;